/** BFP-531 — token balance + burn trend deferred until token module story ships. */

export interface SensemakerTokenMock {
  /** `null` until platform token module is wired — UI shows N/A. */
  balancePercent: number | null
  nearExhaustion: boolean
  burnTrend: Array<{ weekLabel: string; balancePercent: number }>
}

export const TOKEN_WARNING_THRESHOLD_PERCENT = 15

/** Placeholder until token module is implemented (separate story). */
export function buildSensemakerTokenMock(
  _tenantId: string,
  _accountCreatedAt?: string | null,
): SensemakerTokenMock {
  return {
    balancePercent: null,
    nearExhaustion: false,
    burnTrend: [],
  }
}
